import React from 'react';
import FeatureFlagPlaceholder from 'components/ui/FeatureFlagPlaceholder';

export default function TokenHolderDashboard() {
  return (
    <FeatureFlagPlaceholder
      title="Token Holder Dashboard"
      description="Token holder portfolio view, distributions, and transfer activity will be available in Phase 2 following tokenisation launch."
      phase="Phase 2"
    />
  );
}
